"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  breakpoints: {
    100: "240px",
    200: "360px",
    300: "480px",
    400: "600px",
    500: "720px",
    // 45em
    600: "840px",
    700: "960px",
    // 60em
    750: "1020px",
    // 63.75em
    800: "1080px",
    900: "1200px"
  },
  colors: {
    brand: {
      100: "#191A9B",
      200: "#2527BC",
      300: "#2C2EE0",
      500: "#3C5DFF",
      600: "#7C93FF",
      700: "#BFCAFF",
      800: "#EBEFFF",
      900: "#FAFBFF"
    },
    white: {
      100: "#D0D0D4",
      300: "#E4E4E6",
      500: "#F0F1F2",
      600: "#F4F4F5",
      700: "#F7F7FA",
      800: "#FBFBFC",
      900: "#FFFFFF"
    },
    gray: {
      300: "#2E2E39",
      400: "#32383E",
      500: "#4D555B",
      600: "#52585E",
      700: "#656A6F",
      800: "#8E8E9B",
      900: "#9999A5"
    },
    black: {
      100: "#000000",
      300: "#232624"
    },
    red: {
      100: "#A50C3F",
      300: "#DB0F53",
      500: "#E5145A",
      900: "#ffeef0"
    },
    yellow: {
      300: "#EEEA20",
      500: "#FFFB20",
      700: "#FFF4D1",
      900: "#FFFAEB"
    },
    green: {
      100: "#0EA35F",
      300: "#05C476",
      500: "#17DC83",
      900: "#D0EFE1",
      1000: "#E6FFED"
    },
    purple: {
      100: "#682DC7",
      300: "#7A39E3",
      500: "#9350FF",
      900: "#F0E6FF"
    },
    orange: {
      500: "#FF863B",
      400: "#F66161"
    },
    pink: {
      300: "#CA4972",
      500: "#F65C8C"
    }
  },
  effects: {
    shadow: {
      300: "0 2px 4px 0 rgba(228,228,230,1)",
      350: "0 4px 16px 0 rgba(228,228,230,1)"
    }
  }
};
exports.default = _default;